<template>
  <f7-page name="home">
    <div v-if="loaded">
      <div>
        <div class="custom-table-container tableContainer">
          <Samples-summary-table :store="customStore" />
        </div>
      </div>
    </div>
    <!-- <newsInfoPopUp v-if="speaksSpanish && showNewsInfoPopUp" />
    <tutorialPopUp /> -->
  </f7-page>
</template>
<script>
import EventBus from '@/services/event-bus';
import { mapActions, mapState, mapGetters } from 'vuex';
import SamplesSummaryTable from '../components/home/SamplesSummaryTable/SamplesSummaryTable.vue';

export default {
  name: 'Home',
  components: { SamplesSummaryTable },
  data() {
    return {
      loaded: false,
      customStore: null,
      homeEventHandler: null,
    };
  },
  computed: {
    speaksSpanish() {
      const u = this.authenticatedUser;
      if (!u) return false;

      // Siempre obtenemos el idioma actual de la app o el del usuario
      const currentLang =
        this.getLanguage?.toLowerCase() ||
        this.$i18n?.locale?.toLowerCase() ||
        u.language_code?.toLowerCase() ||
        'es';

      // Llama al backend con ese idioma
      this.fetchUrlPeriodVideos(currentLang);
      return true;
    },
    showNewsInfoPopUp() {
      // Se muestra el popup si no ha superado el máximo de veces
      // El vídeo de registro de incidencias solo se muestra a los contactos, no a empleados
      return (
        this.hasRemainingShows &&
        (this.currentVideo?.name === 'Registro de muestras' ||
          (this.currentVideo?.name === 'Registro de incidencias' &&
            this.enabled))
      );
    },
    ...mapState('leftPanel', ['hiddenPanel']),
    ...mapState('user', ['authenticatedUser']),
    ...mapState('contact', ['enabled']),
    ...mapState('videoPeriodModule', ['currentVideo']),
    ...mapGetters('videoPeriodModule', ['hasRemainingShows']),
    ...mapGetters('user', ['getLanguage']),
  },
  beforeMount() {
    this.setCurrentFilter('home');
    this.setCurrentRoute([
      {
        name: this.$t('Home'),
        disabled: false,
        page: 'Home',
        active: true,
      },
    ]);
  },
  async mounted() {
    try {
      this.$f7.preloader.show();

      this.homeEventHandler = async (params) => {
        if (params) {
          this.customStore = await this.getStoreWithFilters(params);
        } else {
          this.customStore = await this.getStore();
        }
      };
      EventBus.$on('Home', this.homeEventHandler);

      const raw = localStorage.getItem('gridallHomeSamples');
      let hasQuickFilters = false;

      if (raw) {
        try {
          const saved = JSON.parse(raw);
          const f = saved.isFilterActive || {};

          hasQuickFilters =
            f.inProcess ||
            f.finished ||
            f.cancelled ||
            f.lastMonth ||
            f.noReviewed ||
            f.onAlert ||
            f.noPositives;
        } catch (e) {
          console.warn('gridallHomeSamples corrupto', e);
        }
      }

      if (!hasQuickFilters) {
        this.applyCurrentFilters();
      }
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t('reEnterCredentials'),
          width: 350,
        },
        'info',
        3000
      );
    } finally {
      this.loaded = true;
      this.$f7.preloader.hide();
    }
  },

  beforeDestroy() {
    EventBus.$off('Home');
  },
  methods: {
    ...mapActions('homeSamples', ['getStore', 'getStoreWithFilters']),
    ...mapActions('filter', [
      'setCurrentFilter',
      'applyCurrentFilters',
    ]),
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('videoPeriodModule', ['fetchUrlPeriodVideos']),
  },
};
</script>
